
import {
    CORE_GET_REPORT_REQUEST,
    CORE_GET_REPORT_SUCCESS,
    CORE_GET_REPORT_FAILURE,

    CORE_GET_EXCEL_REPORT_REQUEST,
    CORE_GET_EXCEL_REPORT_SUCCESS,
    CORE_GET_EXCEL_REPORT_FAILURE,
} from '../types'
import { REQUEST_STATE } from '../types';
const requestState = REQUEST_STATE;

export default {
    report: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_REPORT_REQUEST:
                return state;
            case CORE_GET_REPORT_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload;
                    if (result && data) {
                        return data;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_GET_REPORT_FAILURE:
                return [];
            default:
                return state;
        }
    },
    reportExportExcel: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_EXCEL_REPORT_REQUEST:
                return state;
            case CORE_GET_EXCEL_REPORT_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload;
                    if (result && data) {
                        console.log('data=>',data);
                        return data;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_GET_EXCEL_REPORT_FAILURE:
                return [];
            default:
                return state;
        }
    },
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/reducerReportAPI.js